// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"Relics_fullWidth__pypU9","label":"Relics_label__byrB_","root":"Relics_root__RfSfk","negative":"Relics_negative__iuhOm"};